import { Button, Modal } from "react-bootstrap"
import ThemedModal from "../../../@ui/Modal/ThemedModal"
import { PublicTransportDownloadSource } from "../../../types/LayerAdmin/PublicTransportDownloadSource";

export interface ConfirmMultiIgnoreModalProps {
    show: boolean;
    onClose: () => void;
    sources: PublicTransportDownloadSource[];
    onConfirmed: () => void;
    isIgnoring: boolean;
}

export const ConfirmMultiIgnoreModal = ({ show, onClose, sources, isIgnoring, onConfirmed }: ConfirmMultiIgnoreModalProps) => {
    return <>
        <ThemedModal centered show={show} onHide={onClose}>
            <Modal.Header>
                <Modal.Title>Ignore Multiple Sources</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to set <span className="text-warning">{sources.length} sources</span> as ignored?</p>
                <ul style={{overflowY: "auto", maxHeight: "200px"}} className="list-unstyled">
                    {sources.map((source, index) => (
                        <li key={index}>
                            <strong>{source.name}</strong>
                        </li>
                    ))}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
                <Button variant="danger" onClick={onConfirmed} disabled={isIgnoring}>Yes</Button>
            </Modal.Footer>
        </ThemedModal>
    </>
}